
export default {
    code:'BES_NZ_CARBONCLICK_EVENTS',
    content:{
        transaction: {
            headerText: 'Congratulations! You\'ve made a difference. Here are the details:',
            items: []
        },
    }
}